import { FaPlus, FaPizzaSlice } from 'react-icons/fa';
import { FiX } from 'react-icons/fi';
import { CustomButton } from '../../../../../components/CustomButton';
import { SelectFlavor } from '../SelectFlavor';
import { useCustomTheme } from '../../../../../hooks/useCustomTheme';
import { useFlavors } from './useFlavors';
import * as S from './styles';
import { CustomToggle } from '../../../../../components/CustomToggle';

export const Flavors = ({
  groupId,
  exibirPizzasGrupo,
  setExibirPizzasGrupo,
  desabilitarSabores,
  setDesabilitarSabores,
}) => {
  const { theme: { colors } } = useCustomTheme();

  const {
    group,
    flavors,
    groupSelectedFlavors,
    modalSelectFlavor,
    selectedFlavors,
    handleModalSelectFlavor,
    getSelectedFlavors,
    handleDeleteSelection,
    handleUseSelected,
  } = useFlavors({ groupId });

  const showCustomSelection = !!group?.UsaSaboresSelecionados && !desabilitarSabores && !exibirPizzasGrupo;

  return (
    <S.Container>
      <S.SettingsCard>
        <S.ToggleRow hasBorder={!desabilitarSabores}>
          <S.ToggleText>
            <S.LabelTitle htmlFor="disableFlavors">Não exigir escolha de sabor</S.LabelTitle>
            <S.LabelSubtitle>
              Oculte a etapa de divisão de sabores para os produtos deste grupo (ex: Venda de bebidas).
            </S.LabelSubtitle>
          </S.ToggleText>
          <CustomToggle
            id="disableFlavors"
            checked={desabilitarSabores}
            onChange={() => setDesabilitarSabores((prev) => !prev)}
          />
        </S.ToggleRow>
        {!desabilitarSabores && (
          <S.ToggleRow hasBorder={!exibirPizzasGrupo}>
            <S.ToggleText>
              <S.LabelTitle htmlFor="onlyGroupFlavors">Limitar aos sabores deste grupo</S.LabelTitle>
              <S.LabelSubtitle>
                Restringe a lista do cliente para mostrar somente as pizzas que pertencem a este grupo.
              </S.LabelSubtitle>
            </S.ToggleText>
            <CustomToggle
              id="onlyGroupFlavors"
              checked={exibirPizzasGrupo}
              onChange={() => setExibirPizzasGrupo((prev) => !prev)}
            />
          </S.ToggleRow>
        )}
        {!desabilitarSabores && !exibirPizzasGrupo && (
          <S.ToggleRow disabled={desabilitarSabores}>
            <S.ToggleText>
              <S.LabelTitle htmlFor="selectedFlavors">Personalizar lista de sabores</S.LabelTitle>
              <S.LabelSubtitle>
                Escolha manualmente uma lista específica de pizzas que aparecerão como opção de sabor.
              </S.LabelSubtitle>
            </S.ToggleText>
            <CustomToggle
              id="selectedFlavors"
              checked={!!group?.UsaSaboresSelecionados}
              onChange={handleUseSelected}
            />
          </S.ToggleRow>
        )}
      </S.SettingsCard>
      {showCustomSelection && (
        <>
          <S.SectionHeader>
            <h3>Sabores Liberados</h3>
            <CustomButton
              startIcon={<FaPlus color={colors.white} />}
              onClick={handleModalSelectFlavor}
              appearance="primary"
            >
              Adicionar Sabor
            </CustomButton>
          </S.SectionHeader>

          {groupSelectedFlavors?.length === 0 ? (
            <S.EmptyState>
              <FaPizzaSlice size={24} color="#cbd5e1" />
              <p>Nenhum sabor personalizado foi selecionado.</p>
              <span>Clique no botão acima para escolher quais pizzas os clientes poderão montar.</span>
            </S.EmptyState>
          ) : (
            <S.Content>
              {groupSelectedFlavors?.map((flavor) => (
                <S.FlavorChip key={flavor?.Id}>
                  <S.CardText>{flavor.Descricao}</S.CardText>
                  <S.IconWrapper onClick={() => handleDeleteSelection(flavor.Id)} title="Remover sabor">
                    <FiX size={14} color="#ef4444" />
                  </S.IconWrapper>
                </S.FlavorChip>
              ))}
            </S.Content>
          )}
        </>
      )}
      <SelectFlavor
        open={modalSelectFlavor}
        onClose={handleModalSelectFlavor}
        groupId={groupId}
        flavors={flavors}
        selectedFlavors={selectedFlavors}
        getSelectedFlavors={getSelectedFlavors}
      />
    </S.Container>
  );
};
